import commentaireItem from "./commentaireItem"
export default commentaireItem;
